module.exports = __webpack_public_path__ + "img/Pot2.1351c917.svg";